import { signupCookie } from '@/utils/cookies/signupCookie';

export const termsMap: any = {
    eu: [
        {
            title: <strong>EcoFlow DELTA Pro 3 & DELTA 3 & RIVER 3 & RAPID Power Bank Gift Campaign Terms & Conditions</strong>,
        },
        {
            title: 'The EcoFlow DELTA Pro 3, DELTA 3, RIVER 3 & RAPID Power Bank Gift Campaign runs from 12 August 2024, 9 AM (CET) to 31 December 2024, 9AM (CET). EcoFlow reserves the right to shorten or extend the campaign period at its sole discretion without prior notice.',
        },
        {
            title: <strong>Eligibility</strong>,
        },
        {
            title: 'The campaign is open to all European citizens aged 18 years old and above as of 9 AM on 12 August 2024, 9 AM (CET).',
        },
        {
            title: <strong>Campaign Details</strong>,
        },
        {
            title: 'By entering your email address and subscribing, you agree to email marketing Terms & Conditions, subscribe to EcoFlow marketing emails, and receive updates from EcoFlow.',
        },

        {
            title: (
                <>
                    <strong>1. DELTA Pro 3 Solar Home Battery System Preheat Campaign:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    The first 200 orders of EcoFlow DELTA Pro 3 and its bundles placed between 9 AM on 6 September and 9 AM on 6 October will receive a
                    complimentary EcoFlow Single Axis Solar Tracker. Each order is limited to one{' '}
                    <a href="https://eu.ecoflow.com/products/single-axis-solar-tracker" target="blank">
                        EcoFlow Single Axis Solar Tracker.
                    </a>{' '}
                    Of these first 200 orders for the DELTA Pro 3 and its bundle mentioned above, if the purchaser has subscribed to marketing emails about the
                    EcoFlow DELTA Pro 3 on this preheat event page{' '}
                    <a href="https://eu.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat" target="blank">
                        https://eu.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat
                    </a>{' '}
                    from 9 AM on 12 August to 7:59 AM on 6th September and remains as subscriber when the order is placed, the purchaser will be eligible to the
                    exclusive benefits for subscribers: a free EcoFlow Single Axis Solar Tracker and a two-year extended warranty for the purchased EcoFlow
                    DELTA Pro 3.
                    <br />
                    Each email address is eligible to receive the benefit of the two-year extended warranty on only one purchased EcoFlow DELTA Pro 3. The email
                    address used by the purchaser to place the order must be the same as the email address used to subscribe to the EcoFlow DELTA Pro 3
                    marketing emails during the preheat period and must remain subscribed at the time of payment and within 24 hours of payment. If the
                    purchaser unsubscribes at the time of payment and within 24 hours of payment, they cannot receive the confirmation email for the extended
                    warranty benefits. The purchaser can check the order update email after 24 hours of payment, or register for an EcoFlow account and then log
                    in to{' '}
                    <a
                        href="       https://account.ecoflow.com/login?return_to=eu.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=eu.ecoflow.com/
                    </a>{' '}
                    to confirm that the 2-year extended warranty has been added to the eligible order. The 2-year extended warranty shown on the order page is a
                    virtual product that will not be issued physically. Please protect your warranty information such as SN code, proof of purchase (invoice),
                    and extended warranty issuance email from being leaked. EcoFlow is not responsible for any financial loss due to leakage of warranty
                    information caused by customers.
                </>
            ),
        },
        {
            title: (
                <>
                    For the full terms & conditions, please visit{' '}
                    <a href="https://eu.ecoflow.com/products/delta-pro-3-portable-power-station" target="blank">
                        https://eu.ecoflow.com/products/delta-pro-3-portable-power-station
                    </a>{' '}
                </>
            ),
        },

        {
            title: (
                <>
                    <strong>2. DELTA 3 Series Gift Campaign: </strong>
                </>
            ),
        },
        {
            title: 'Products eligible include: EcoFlow DELTA 3 Series Portable Power Station and its bundles',
        },
        {
            title: 'Dedicated Gift: 1 × EcoFlow RAPID (5000mAh)',
        },
        {
            title: 'Available Quantities of Gift: 200',
        },

        {
            title: (
                <>
                    <strong>3. RIVER 3 Series Gift Campaign: </strong>
                </>
            ),
        },
        {
            title: 'Products eligible include: EcoFlow RIVER 3 Series Portable Power Station and its bundles',
        },
        {
            title: 'Dedicated Gift: 1 × EcoFlow Camping Light',
        },
        {
            title: 'Available Quantities of Gift: 200',
        },
        {
            title: (
                <>
                    <strong>4. RAPID Power Bank Gift Campaign: </strong>
                </>
            ),
        },
        {
            title: 'Products eligible include: EcoFlow RAPID Magnetic Power Bank (5000/10000mAh) and its bundles',
        },
        {
            title: 'Dedicated Gift: 1 × EcoFlow Shoulder Bag or 1 × EcoFlow Tote Bag',
        },
        {
            title: 'Available Quantities of Gift: 200',
        },
        {
            title: (
                <>
                    <strong>Note:</strong>
                </>
            ),
        },
        {
            title: '1. The start time of the campaign is when the product is available for sale, subject to the open sale information on the official website. ',
        },
        {
            title: (
                <>
                    2. The above-mentioned first 200 orders are counted within the following 5 official EcoFlow websites:{' '}
                    <a href="https://eu.ecoflow.com" target="blank">
                        eu.ecoflow.com
                    </a>
                    ,{' '}
                    <a href="https://de.ecoflow.com" target="blank">
                        de.ecoflow.com
                    </a>
                    ,{' '}
                    <a href="https://fr.ecoflow.com" target="blank">
                        fr.ecoflow.com
                    </a>
                    ,{' '}
                    <a href="https://it.ecoflow.com" target="blank">
                        it.ecoflow.com
                    </a>
                    , and{' '}
                    <a href="https://es.ecoflow.com" target="blank">
                        es.ecoflow.com
                    </a>
                    .A total of 200 gifts will be given away across the 5 websites. The start of the count is based on the website's announcement. The eligible
                    orders are sorted in the chronological order of payment. If the gifts run out, the offer will be discontinued without further notification
                    from the website. The gift will be automatically added to the order within 24 hours of payment. The customer will be able to view the gift
                    in the order by logging into the account ({' '}
                    <a
                        href="https://account.ecoflow.com/login?return_to=eu.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=eu.ecoflow.com/
                    </a>
                    ) through the official website where the purchase was made.
                </>
            ),
        },
        {
            title: '3.  If a refund is issued for the original order, the gift must be returned, and the two-year extended warranty for the EcoFlow DELTA Pro 3 (available exclusively to subscribers during the preheat campaign) will be invalidated. No separate notice of invalidation will be provided.',
        },
        {
            title: (
                <>
                    <strong>General:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    1. If you encounter any problems during the promotion, please contact <a href="mailto:support.eu@ecoflow.com">support.eu@ecoflow.com</a> for
                    assistance
                </>
            ),
        },
        {
            title: '2. To the extent permitted by applicable law, we may decide to modify these rules or cancel the promotion at any time. If there is any fraud or abuse related to the promotion, we reserve the right to exclude any customer from the promotion.',
        },
        {
            title: "3. Participants in the Sale agree to be bound by the terms and conditions set forth herein and understand that EcoFlow's decisions are final and binding. No correspondence or appeals will be entertained. EcoFlow reserves the right to make the final and ultimate interpretation of this campaign.",
        },
        {
            title: "4. All orders must comply with EcoFlow's purchase agreement and return policy during the sale promotion.",
        },
        {
            title: '5. The sale promotion does not apply to wholesale on distributor orders.',
        },
        {
            title: '6. Any unauthorized or fraudulent behaviour will result in the disqualification of participants.',
        },
        {
            title: '7. Participants must comply with all applicable laws and regulations. ',
        },
        {
            title: '8. EcoFlow reserves the right to stop, cancel, or change the promotion at any time during the promotion. Any changes will be announced on the EcoFlow official website.',
        },
        {
            title: "9. All prizes in this promotion are limited in quantity and are available on a first-come, first-served basis. Any matters not covered herein will be handled according to EcoFlow's final interpretation.",
        },
        {
            title: '10. EcoFlow will assume no responsibility for late entries, which may occur for any reason, including but not limited to network transmission failure.',
        },
        {
            title: '11. EcoFlow will not be responsible for any direct or indirect losses or damages incurred by any party, including the participants, in connection with or arising from acts or omissions or any way related to this campaign.',
        },
        {
            title: "12. Participants agree to release and discharge EcoFlow from any liabilities and claims, including breach of contract, tort, negligence, or any other cause of action at law or equity, arising out of or in any way connected to this campaign or the participant's entry into the campaign.",
        },
    ],
    uk: [
        {
            title: <strong>EcoFlow DELTA Pro 3 & DELTA 3 & RIVER 3 & RAPID Power Bank Gift Campaign Terms & Conditions</strong>,
        },
        {
            title: 'The EcoFlow DELTA Pro 3, DELTA 3, RIVER 3 & RAPID Power Bank Gift Campaign runs from 12 August 2024, 9 AM (BST) to 31 December 2024, 9AM (BST). EcoFlow reserves the right to shorten or extend the campaign period at its sole discretion without prior notice.',
        },
        {
            title: <strong>Eligibility</strong>,
        },
        {
            title: 'The campaign is open to all UK citizens aged 18 years old and above as of 9 AM on 12 August 2024, 9 AM (BST).',
        },
        {
            title: <strong>Campaign Details</strong>,
        },
        {
            title: 'By entering your email address and subscribing, you agree to email marketing Terms & Conditions, subscribe to EcoFlow marketing emails, and receive updates from EcoFlow.',
        },

        {
            title: (
                <>
                    <strong>1. DELTA Pro 3 Solar Home Battery System Preheat Campaign:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    The first 50 orders of EcoFlow DELTA Pro 3 and its bundles will receive a complimentary{' '}
                    <a href="https://uk.ecoflow.com/products/single-axis-solar-tracker" target="blank">
                        EcoFlow Single Axis Solar Tracker
                    </a>
                    . Each order is limited to one EcoFlow Single Axis Solar Tracker. The above-mentioned first 50 orders are counted within the official
                    EcoFlow website:
                    <a href="https://uk.ecoflow.com/" target="blank">
                        uk.ecoflow.com.
                    </a>
                    total of 50 gifts will be given away. The start of the count is based on the website's announcement of the EcoFlow DELTA Pro 3 launch time.
                    The eligible orders are sorted in the chronological order of payment.
                </>
            ),
        },
        {
            title: (
                <>
                    For the full terms & conditions, please visit{' '}
                    <a href="https://uk.ecoflow.com/products/delta-pro-3-portable-power-station" target="blank">
                        https://uk.ecoflow.com/products/delta-pro-3-portable-power-station
                    </a>
                </>
            ),
        },

        {
            title: (
                <>
                    <strong>2. DELTA 3 Series Gift Campaign: </strong>
                </>
            ),
        },
        {
            title: 'Products eligible include: EcoFlow DELTA 3 Series Portable Power Station and its bundles',
        },
        {
            title: 'Dedicated Gift: 1 × EcoFlow RAPID (5000mAh)',
        },
        {
            title: 'Available Quantities of Gift: 50',
        },

        {
            title: (
                <>
                    <strong>3. RIVER 3 Series Gift Campaign: </strong>
                </>
            ),
        },
        {
            title: 'Products eligible include: EcoFlow RIVER 3 Series Portable Power Station and its bundles',
        },
        {
            title: 'Dedicated Gift: 1 × EcoFlow Camping Light',
        },
        {
            title: 'Available Quantities of Gift: 50',
        },

        {
            title: (
                <>
                    <strong>4. RAPID Power Bank Gift Campaign: </strong>
                </>
            ),
        },
        {
            title: 'Products eligible include: EcoFlow RAPID Magnetic Power Bank (5000/10000mAh) and its bundles',
        },
        {
            title: 'Dedicated Gift: 1 × EcoFlow Shoulder Bag or 1 × EcoFlow Tote Bag',
        },
        {
            title: 'Available Quantities of Gift: 50',
        },

        {
            title: (
                <>
                    <strong>Note:</strong>
                </>
            ),
        },
        {
            title: '1. The start time of the campaign is when the product is available for sale, subject to the sale information on the official website. ',
        },
        {
            title: (
                <>
                    2. The above-mentioned first 50 orders are counted within the official EcoFlow website:{' '}
                    <a href="https://uk.ecoflow.com" target="blank">
                        uk.ecoflow.com.
                    </a>
                    A total of 50 gifts will be given away. The start of the count is based on the website's announcement. The eligible orders are sorted in the
                    chronological order of payment. If the gifts run out, the offer will be discontinued without further notification from the website. The gift
                    will be automatically added to the order within 24 hours of payment. The customer will be able to view the gift in the order by logging into
                    the account (
                    <a
                        href="https://account.ecoflow.com/login?return_to=uk.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=uk.ecoflow.com/
                    </a>
                    ) through the official website where the purchase was made.
                </>
            ),
        },
        {
            title: '3. If a refund is issued on the original order, the gift must be returned upon refund.',
        },
        {
            title: (
                <>
                    <strong>General:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    1. If you encounter any problems during the promotion, please contact <a href="mailto:support.eu@ecoflow.com">support.eu@ecoflow.com</a> for
                    assistance
                </>
            ),
        },
        {
            title: '2. To the extent permitted by applicable law, we may decide to modify these rules or cancel the promotion at any time. If there is any fraud or abuse related to the promotion, we reserve the right to exclude any customer from the promotion.',
        },
        {
            title: "3. Participants in the Sale agree to be bound by the terms and conditions set forth herein and understand that EcoFlow's decisions are final and binding. No correspondence or appeals will be entertained. EcoFlow reserves the right to make the final and ultimate interpretation of this campaign.",
        },
        {
            title: "4. All orders must comply with EcoFlow's purchase agreement and return policy during the sale promotion.",
        },
        {
            title: '5. The sale promotion does not apply to wholesale on distributor orders.',
        },
        {
            title: '6. Any unauthorized or fraudulent behaviour will result in the disqualification of participants.',
        },
        {
            title: '7. Participants must comply with all applicable laws and regulations. ',
        },
        {
            title: '8. EcoFlow reserves the right to stop, cancel, or change the promotion at any time during the promotion. Any changes will be announced on the EcoFlow official website.',
        },
        {
            title: "9. All prizes in this promotion are limited in quantity and are available on a first-come, first-served basis. Any matters not covered herein will be handled according to EcoFlow's final interpretation.",
        },
        {
            title: '10. EcoFlow will assume no responsibility for late entries, which may occur for any reason, including but not limited to network transmission failure.',
        },
        {
            title: '11. EcoFlow will not be responsible for any direct or indirect losses or damages incurred by any party, including the participants, in connection with or arising from acts or omissions or any way related to this campaign.',
        },
        {
            title: "12. Participants agree to release and discharge EcoFlow from any liabilities and claims, including breach of contract, tort, negligence, or any other cause of action at law or equity, arising out of or in any way connected to this campaign or the participant's entry into the campaign.",
        },
    ],
    de: [
        {
            title: <strong>Geschäftsbedingungen für die Geschenkkampagne für EcoFlow DELTA Pro 3, DELTA 3, RIVER 3 & RAPID Powerbank</strong>,
        },
        {
            title: 'Die Geschenkkampagne für EcoFlow DELTA Pro 3, DELTA 3, RIVER 3 & RAPID Powerbank läuft vom 12. August 2024 um 09:00 Uhr (MEZ) bis zum 31. Dezember 2024 um 09:00 Uhr (MEZ). EcoFlow behält sich das Recht vor, den Kampagnenzeitraum nach eigenem Ermessen und ohne vorherige Ankündigung zu verkürzen oder zu verlängern.',
        },
        {
            title: <strong>Berechtigung</strong>,
        },
        {
            title: ' Die Kampagne steht allen europäischen Bürgern offen, die am 12. August 2024 um 9 Uhr morgens (MEZ) 18 Jahre alt oder älter sind.',
        },
        {
            title: <strong>Kampagnendetails</strong>,
        },
        {
            title: 'Durch Eingabe Ihrer E-Mail Adresse und Anmeldung stimmen Sie den Allgemeinen Geschäftsbedingungen für E-Mail Marketing zu, abonnieren EcoFlow Marketing-E-Mails und erhalten Updates von EcoFlow.',
        },

        {
            title: (
                <>
                    <strong>1. Warm-up-Kampagne zum DELTA Pro 3 Solarbatteriesystem:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    Die ersten 200 Bestellungen von EcoFlow DELTA Pro 3 und den dazugehörigen Bundle, die zwischen dem 6. September, 9:00 Uhr, und dem 6.
                    Oktober, 9:00 Uhr, eingehen, erhalten einen{' '}
                    <a href="https://de.ecoflow.com/products/single-axis-solar-tracker" target="blank">
                        EcoFlow Solar Tracker
                    </a>{' '}
                    als Gratiszugabe. Pro Bestellung wird nur ein EcoFlow Solar Tracker ausgegeben.
                    <br />
                    Von diesen ersten 200 Bestellungen von DELTA Pro 3 und der oben erwähnten Bundle hat der Käufer, wenn er sich auf dieser Warm-up
                    Kampagnenseite{' '}
                    <a href="https://de.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat" target="blank">
                        https://de.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat
                    </a>{' '}
                    zwischen dem 12. August, 9:00 Uhr, und dem 6. September, 7:59 Uhr, für Marketing E-Mails zum EcoFlow DELTA Pro 3 anmeldet und zum Zeitpunkt
                    der Bestellung Abonnent bleibt, Anspruch auf die exklusiven Vorteile für Abonnenten: einen KOSTENLOSEN EcoFlow Solar Tracker und eine
                    zweijährige Garantieverlängerung für die erworbene EcoFlow DELTA Pro 3.
                    <br />
                    Pro E-Mail Adresse kann nur ein gekaufter EcoFlow DELTA Pro 3 von der zweijährigen Garantieverlängerung profitieren. Die vom Käufer für die
                    Bestellung verwendete E-Mail Adresse muss mit der E-Mail Adresse übereinstimmen, die er für das Abonnement der Marketing E-Mails von EcoFlow
                    DELTA Pro 3 während der Warm-up Kampagne verwendet hat, und muss zum Zeitpunkt der Zahlung und innerhalb von 24 Stunden nach der Zahlung
                    noch angemeldet sein. Wenn sich der Käufer zum Zeitpunkt der Zahlung und innerhalb von 24 Stunden nach der Zahlung abmeldet, kann er die
                    Bestätigungs-E-Mail für die erweiterten Garantieleistungen nicht erhalten. Der Käufer kann die E-Mail zur Aktualisierung der Bestellung 24
                    Stunden nach der Zahlung überprüfen oder sich für ein EcoFlow Konto registrieren und sich dann auf{' '}
                    <a
                        href="https://account.ecoflow.com/login?return_to=de.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=de.ecoflow.com/
                    </a>{' '}
                    einloggen, um zu bestätigen, dass die 2-Jahres-Garantieverlängerung zu der berechtigten Bestellung hinzugefügt wurde. Die auf der
                    Bestellseite angegebene 2-Jahres-Garantieverlängerung ist ein virtuelles Produkt, das nicht physisch ausgestellt wird. Bitte schützen Sie
                    Ihre Garantieinformationen wie den SN-Code, den Kaufnachweis (Rechnung) und die E-Mail zur Ausstellung der Garantieverlängerung vor
                    unbefugtem Zugriff. EcoFlow ist nicht verantwortlich für finanzielle Verluste, die durch die Weitergabe von Garantieinformationen durch
                    Kunden verursacht werden.
                </>
            ),
        },
        {
            title: (
                <>
                    Die vollständigen Bedingungen finden Sie unter{' '}
                    <a href="https://de.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat" target="blank">
                        https://de.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat.
                    </a>
                </>
            ),
        },
        {
            title: (
                <>
                    <strong>2. Geschenkkampagne für DELTA 3-Serie: </strong>
                </>
            ),
        },
        {
            title: 'Zu den teilnahmeberechtigten Produkten gehören: Tragbare Powerstation der Serie EcoFlow DELTA 3 und zugehörige Bundles',
        },
        {
            title: 'Geschenk: 1 × EcoFlow RAPID (5 000 mAh)',
        },
        {
            title: 'Anzahl der verfügbaren Geschenke: 200',
        },

        {
            title: (
                <>
                    <strong>3. Geschenkkampagne für RIVER 3-Serie: </strong>
                </>
            ),
        },
        {
            title: 'Zu den teilnahmeberechtigten Produkten gehören: Tragbare Powerstation der Serie EcoFlow RIVER 3 und zugehörige Bundles',
        },
        {
            title: 'Geschenk: 1 × EcoFlow Campinglampe',
        },
        {
            title: 'Anzahl der verfügbaren Geschenke: 200',
        },
        {
            title: (
                <>
                    <strong>4. Geschenkkampagne für RAPID Magnetische Powerbank: </strong>
                </>
            ),
        },
        {
            title: 'Zu den teilnahmeberechtigten Produkten gehören: Magnetische Powerbank EcoFlow RAPID (5 000/10 000 mAh) und zugehörige Bundles',
        },
        {
            title: 'Geschenk: 1 × EcoFlow Schultertasche oder 1 × EcoFlow Tragetasche',
        },
        {
            title: 'Anzahl der verfügbaren Geschenke: 200',
        },
        {
            title: (
                <>
                    <strong>Hinweis:</strong>
                </>
            ),
        },
        {
            title: '1. Die Kampagne beginnt, wenn das Produkt vorbehaltlich der Informationen zum offenen Verkauf auf der offiziellen Website zum Verkauf angeboten wird. ',
        },
        {
            title: (
                <>
                    2. Die oben genannten ersten 200 Bestellungen werden auf den folgenden 5 offiziellen Webseiten von EcoFlow gezählt:{' '}
                    <a href="https://eu.ecoflow.com" target="blank">
                        eu.ecoflow.com
                    </a>
                    ,{' '}
                    <a href="https://de.ecoflow.com" target="blank">
                        de.ecoflow.com
                    </a>
                    ,{' '}
                    <a href="https://fr.ecoflow.com" target="blank">
                        fr.ecoflow.com
                    </a>
                    ,{' '}
                    <a href="https://it.ecoflow.com" target="blank">
                        it.ecoflow.com
                    </a>
                    , und{' '}
                    <a href="https://es.ecoflow.com" target="blank">
                        es.ecoflow.com.
                    </a>
                    Auf den 5 Webseiten werden insgesamt 200 Gratiszugaben vergeben. Der Beginn der Zählung hängt von der Bekanntgabe auf der Webseite ab. Die
                    in Frage kommenden Bestellungen werden in der chronologischen Reihenfolge des Zahlungseingangs sortiert. Wenn alle Geschenke vergeben
                    wurden, läuft das Angebot ohne weitere Benachrichtigung auf der Website aus. Wenn die Bestellung in Frage kommt, wird das Geschenk innerhalb
                    von 24 Stunden nach der Zahlung automatisch zur Bestellung hinzugefügt. Der Kunde kann das Geschenk in der Bestellung einsehen, wenn er sich
                    über die offizielle Website ({' '}
                    <a
                        href="https://account.ecoflow.com/login?return_to=de.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=de.ecoflow.com/
                    </a>
                    ), auf der der Kauf getätigt wurde, in seinem Konto anmeldet.
                </>
            ),
        },
        {
            title: '3. Wenn die ursprüngliche Bestellung erstattet wird, muss das Geschenk zurückgegeben werden und die zweijährige Garantieverlängerung für EcoFlow DELTA Pro 3 (exklusiv für Abonnenten während der Warm-up Kampagne) wird bei der Erstattung ungültig. Es wird keine gesonderte Benachrichtigung über die Ungültigkeit erfolgen.',
        },
        {
            title: (
                <>
                    <strong>Allgemein:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    1. Sollten während der Aktion Probleme auftreten, wenden Sie sich bitte an{' '}
                    <a href="mailto:support.eu@ecoflow.com">support.eu@ecoflow.com</a>.
                </>
            ),
        },
        {
            title: '2. Soweit gesetzlich zulässig, können wir jederzeit beschließen, die Regeln zu ändern oder die Aktion zu beenden. Bei Betrug oder Missbrauch im Zusammenhang mit der Aktion behalten wir uns das Recht vor, den Kunden von der Aktion auszuschließen.',
        },
        {
            title: '3. Die Teilnehmer der Kampagne erklären sich mit diesen Geschäftsbedingungen einverstanden und erkennen an, dass die Entscheidungen von EcoFlow endgültig und bindend sind. Korrespondenz oder Einsprüche werden nicht entgegengenommen. EcoFlow behält sich das Recht auf die endgültige und abschließende Auslegung dieser Kampagne vor.',
        },
        {
            title: '4. Während der Kampagne müssen alle Bestellungen den EcoFlow Verkaufsbedingungen und Rückgaberichtlinien entsprechen.',
        },
        {
            title: '5. Diese Werbeaktion gilt nicht für Bestellungen von Großhändlern oder Distributoren.',
        },
        {
            title: '6. Jegliches unbefugte oder betrügerische Verhalten führt zur Disqualifikation der Teilnehmer.',
        },
        {
            title: '7. Die Teilnehmer müssen sich an alle geltenden Gesetze und Vorschriften halten.',
        },
        {
            title: '8. EcoFlow behält sich das Recht vor, die Aktion jederzeit zu beenden, abzubrechen oder zu ändern. Alle Änderungen werden auf der offiziellen EcoFlow Webseite bekannt gegeben.',
        },
        {
            title: '9. Alle Preise dieser Aktion sind in der Menge begrenzt und werden nach dem Prinzip „Wer zuerst kommt, mahlt zuerst“ vergeben. Alle hierin nicht behandelten Angelegenheiten werden gemäß der endgültigen Auslegung von EcoFlow behandelt.',
        },
        {
            title: '10. EcoFlow übernimmt keine Verantwortung für verspätete Einträge, die aus irgendeinem Grund auftreten können, einschließlich, aber nicht beschränkt auf Netzwerkübertragungsfehler.',
        },
        {
            title: '11. EcoFlow ist nicht verantwortlich für direkte oder indirekte Verluste oder Schäden, die einer Partei, einschließlich der Teilnehmer, im Zusammenhang mit oder aufgrund von Handlungen oder Unterlassungen oder in irgendeiner Weise im Zusammenhang mit dieser Kampagne entstehen.',
        },
        {
            title: '12. Die Teilnehmer erklären sich damit einverstanden, EcoFlow von sämtlichen Verbindlichkeiten und Ansprüchen freizustellen, einschließlich Vertragsbruch, unerlaubter Handlung, Fahrlässigkeit oder anderen Klagegründen nach Gesetz oder Billigkeit, die sich aus dieser Kampagne oder der Teilnahme des Teilnehmers an der Kampagne ergeben oder in irgendeiner Weise damit in Zusammenhang stehen Kampagne.',
        },
    ],
    fr: [
        {
            title: <strong>Conditions générales de la campagne de cadeaux EcoFlow DELTA Pro 3, DELTA 3, RIVER 3 et Batterie externe magnétique RAPID</strong>,
        },
        {
            title: 'La campagne de cadeaux EcoFlow DELTA Pro 3, DELTA 3, RIVER 3 et Batterie externe magnétique RAPID se déroulera du 12 août 2024 à 9 h (CET) au 31 décembre 2024 à 9 h (CET). EcoFlow se réserve le droit de raccourcir ou de prolonger la période promotionnelle, à sa seule discrétion et sans préavis.',
        },
        {
            title: <strong>Éligibilité</strong>,
        },
        {
            title: ' La campagne est ouverte à tous les citoyens européens âgés de 18 ans ou plus à partir du 12 août 2024 à 9 heures (CET).',
        },
        {
            title: <strong>Détails de la campagne</strong>,
        },
        {
            title: "En saisissant votre adresse e-mail et en vous abonnant, vous acceptez de recevoir des communications marketing d'EcoFlow conformément à nos Conditions générales relatives aux communications marketing et à recevoir des actualités de la part d'EcoFlow.",
        },

        {
            title: (
                <>
                    <strong>1. Campagne de pré-lancement du système photovoltaïque domestique à batterie DELTA Pro 3 :</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    Les 200 premiers clients à commander un modèle EcoFlow DELTA Pro 3 et ses offres groupées entre 9 heures le 6 septembre et 9 heures le 6
                    octobre recevront gratuitement un{' '}
                    <a href="https://fr.ecoflow.com/products/single-axis-solar-tracker" target="blank">
                        tracker solaire à axe unique EcoFlow.
                    </a>{' '}
                    Chaque commande est limitée à un seul tracker solaire à axe unique EcoFlow.
                    <br />
                    Parmi les 200 premières commandes de DELTA Pro 3 et de ses offres groupées mentionnées ci-dessus, si l'acheteur s'est abonné aux
                    communications marketing concernant EcoFlow DELTA Pro 3 sur cette page d'événement de pré-lancement :{' '}
                    <a href="https://fr.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat" target="blank">
                        https://fr.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat
                    </a>{' '}
                    entre le 12 août à 9 heures et le 6 septembre à 7h59 et s'il reste abonné au moment de la commande, il sera éligible aux avantages exclusifs
                    pour les abonnés : un tracker solaire à axe unique EcoFlow gratuit et une garantie prolongée de deux ans pour le modèle EcoFlow DELTA Pro 3
                    acheté. <br />
                    Chaque adresse e-mail est éligible pour bénéficier d’une garantie prolongée de deux ans concernant un modèle EcoFlow DELTA Pro 3 acheté.
                    L’adresse e-mail utilisée par l’acheteur pour la commande doit correspondre à celle qu’il a utilisée pour s’abonner aux e-mails marketing
                    sur EcoFlow DELTA Pro 3 pendant la période de pré-lancement. Il doit être abonné au moment du paiement et dans les 24 heures qui suivent ce
                    dernier. Si l’acheteur se désabonne au moment du paiement ou dans les 24 heures qui suivent, il ne pourra pas recevoir l’e-mail de
                    confirmation associé à l’octroi de la garantie prolongée. L’acheteur peut vérifier l’envoi de l’e-mail sur les nouvelles informations de la
                    commande dans les 24 heures suivant le paiement, ou créer un compte EcoFlow et se connecter à l’adresse{' '}
                    <a
                        href="https://account.ecoflow.com/login?return_to=fr.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=fr.ecoflow.com/
                    </a>{' '}
                    pour confirmer que la garantie prolongée de 2 ans a bien été ajoutée à la commande éligible. La garantie prolongée de 2 ans affichée sur la
                    page de la commande est un produit virtuel, et non physique. Veuillez protéger vos informations de garantie (code NS, document d’achat
                    (facture) et e-mail de lancement de la garantie prolongée) contre toute fuite. EcoFlow n’est pas responsable des pertes financières dues à
                    la fuite d’informations sur la garantie causée par le client.
                </>
            ),
        },
        {
            title: (
                <>
                    Pour en savoir plus sur les conditions générales, rendez-vous sur{' '}
                    <a href="https://fr.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat" target="blank">
                        https://fr.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat.
                    </a>
                </>
            ),
        },

        {
            title: (
                <>
                    <strong>2. Campagne de cadeaux de la Série DELTA 3 : </strong>
                </>
            ),
        },
        {
            title: 'Les produits éligibles comprennent : la station électrique portable EcoFlow Série DELTA 3 et ses offres groupées',
        },
        {
            title: 'Cadeau spécial : EcoFlow RAPID (5 000 mAh)',
        },
        {
            title: 'Quantité de cadeaux disponibles : 200',
        },

        {
            title: (
                <>
                    <strong>3. Campagne de cadeaux de la Série RIVER 3 : </strong>
                </>
            ),
        },
        {
            title: 'Les produits éligibles comprennent : la station électrique portable EcoFlow Série RIVER 3 et ses offres groupées',
        },
        {
            title: 'Cadeau spécial : Lampe de camping EcoFlow',
        },
        {
            title: 'Quantité de cadeaux disponibles : 200',
        },
        {
            title: (
                <>
                    <strong>4. Campagne de cadeaux de la batterie externe Rapid : </strong>
                </>
            ),
        },
        {
            title: 'Les produits éligibles comprennent : la batterie externe magnétique EcoFlow RAPID (5 000/10 000 mAh) et ses offres groupées',
        },
        {
            title: 'Cadeau spécial : Sac bandoulière EcoFlow ou Sac fourre-tout EcoFlow',
        },
        {
            title: 'Quantité de cadeaux disponibles : 200',
        },
        {
            title: (
                <>
                    <strong>Remarque:</strong>
                </>
            ),
        },
        {
            title: '1. La campagne débute lorsque le produit est disponible à la vente, sous réserve des informations relatives à la vente ouverte sur le site Web officiel. ',
        },
        {
            title: (
                <>
                    2. Les 200 premières commandes mentionnées ci-dessus incluent les 5 sites Web officiels de EcoFlow :{' '}
                    <a href="https://eu.ecoflow.com" target="blank">
                        eu.ecoflow.com
                    </a>
                    ,
                    <a href="https://de.ecoflow.com" target="blank">
                        de.ecoflow.com
                    </a>
                    ,
                    <a href="https://fr.ecoflow.com" target="blank">
                        fr.ecoflow.com
                    </a>
                    ,
                    <a href="https://it.ecoflow.com" target="blank">
                        it.ecoflow.com
                    </a>
                    et{' '}
                    <a href="https://es.ecoflow.com" target="blank">
                        es.ecoflow.com.
                    </a>{' '}
                    Un total de 200 cadeaux seront répartis sur les 5 sites Web. Le début du décompte repose sur l’annonce. Les commandes éligibles sont triées
                    selon l’ordre chronologique des paiements. Lorsqu'il n'y aura plus de cadeaux disponibles, l'offre sera interrompue sans aucune notification
                    de la part du site Web. Si la commande est éligible, le cadeau sera automatiquement ajouté à la commande dans les 24 heures suivant le
                    paiement. Le client pourra visualiser le cadeau dans la commande en se connectant sur le site officiel ({' '}
                    <a
                        href="https://account.ecoflow.com/login?return_to=fr.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=fr.ecoflow.com/
                    </a>
                    ) où l'achat a été effectué.
                </>
            ),
        },
        {
            title: "3. Si un remboursement est effectué sur la commande initiale, le cadeau doit être renvoyé. L'extension de garantie de deux ans pour EcoFlow DELTA Pro 3 (exclusivement pour les abonnés pendant la campagne de pré-lancement) sera invalidée. Aucun avis signalant l’invalidation ne sera fourni.",
        },
        {
            title: (
                <>
                    <strong>Généralités:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    1. Si vous rencontrez des problèmes pendant la période de la promotion, veuillez contacter{' '}
                    <a href="mailto:support.eu@ecoflow.com">support.eu@ecoflow.com</a> pour obtenir de l’aide.
                </>
            ),
        },
        {
            title: '2. Dans la mesure permise par la loi applicable, nous pouvons décider de modifier ces règles ou d’annuler la promotion à tout moment. En cas de fraude ou d’abus lié à la promotion, nous nous réservons le droit d’exclure tout client de la promotion.',
        },
        {
            title: '3. Les participants acceptent d’être liés par les termes et conditions énoncés ici et comprennent que les décisions d’EcoFlow sont finales et sans appel. Aucune correspondance ni appel ne sera pris en considération. EcoFlow se réserve le droit de faire l’interprétation finale et définitive de cet événement.',
        },
        {
            title: '4. Pendant la période promotionnelle, toutes les commandes doivent être conformes au contrat d’achat et à la politique de retour d’EcoFlow.',
        },
        {
            title: '5. L’offre promotionnelle n’est pas applicable aux commandes de grossistes ou de distributeurs.',
        },
        {
            title: '6. Tout comportement non autorisé ou frauduleux entraînera la disqualification des participants.',
        },
        {
            title: '7. Les participants doivent se conformer à toutes les lois et réglementations applicables.',
        },
        {
            title: '8. EcoFlow se réserve le droit d’arrêter, d’annuler ou de modifier l’offre promotionnelle à tout moment pendant la promotion. Tout changement sera annoncé sur le site officiel d’EcoFlow.',
        },
        {
            title: '9. Tous les prix de cette offre spéciale sont en quantité limitée et sont disponibles selon le principe du « premier arrivé, premier servi ». Toutes les questions non couvertes ici seront traitées selon l’interprétation finale d’EcoFlow.',
        },
        {
            title: '10. EcoFlow ne sera pas responsable des inscriptions tardives qui pourraient survenir pour quelque raison que ce soit, y compris mais sans s’y limiter, la défaillance de la transmission réseau.',
        },
        {
            title: '11. EcoFlow ne sera pas responsable des pertes ou dommages directs ou indirects subis par toute partie, y compris les participants, en relation avec, ou découlant d’actes ou d’omissions, ou de toute manière liés à cette promotion.',
        },
        {
            title: '12. Les participants conviennent de libérer et décharger EcoFlow de toute responsabilité et réclamation, y compris pour violation de contrat, délit, négligence, ou toute autre action en droit ou en équité, découlant de ou en lien de quelque manière que ce soit avec cette promotion.',
        },
    ],
    it: [
        {
            title: <strong>Termini e condizioni della campagna regalo EcoFlow DELTA Pro 3, DELTA 3, RIVER 3 e Power bank magnetica RAPID</strong>,
        },
        {
            title: 'La campagna regalo EcoFlow DELTA Pro 3, DELTA 3, RIVER 3 e Power bank magnetica RAPID si svolge dalle 09:00 (CEST) del 12 agosto 2024 alle 09:00 (CET) dell’31 dicembre 2024. EcoFlow si riserva il diritto di ridurre o estendere il periodo di validità della campagna, a sua esclusiva discrezione e senza alcun preavviso.',
        },
        {
            title: <strong>Idoneità</strong>,
        },
        {
            title: 'Possono partecipare alla campagna tutti i cittadini europei che hanno almeno 18 anni di età alle 09:00 (CEST) del 12 agosto 2024.',
        },
        {
            title: <strong>Informazioni sulla campagna</strong>,
        },
        {
            title: 'Inserendo il tuo indirizzo e-mail e iscrivendoti, accetti i Termini e condizioni per l’e-mail marketing e ti iscrivi per ricevere le e-mail di marketing di EcoFlow e aggiornamenti da EcoFlow.',
        },

        {
            title: (
                <>
                    <strong>1. Campagna di prevendita per il sistema a batteria solare per la casa DELTA Pro 3:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    I primi 200 ordini di EcoFlow DELTA Pro 3 e dei relativi set effettuati tra le ore 9:00 del 6 settembre e le ore 9:00 del 6 ottobre
                    riceveranno in omaggio un{' '}
                    <a href="https://it.ecoflow.com/products/single-axis-solar-tracker" target="blank">
                        inseguitore solare ad asse singolo EcoFlow.
                    </a>{' '}
                    Ogni ordine è limitato a un inseguitore solare ad asse singolo EcoFlow.
                    <br />
                    Tra questi primi 200 ordini di DELTA Pro 3 e dei relativi set di cui sopra, gli acquirenti che hanno effettuato l’iscrizione per ricevere
                    e-mail di marketing su EcoFlow DELTA Pro 3 sulla pagina dell’evento di prevendita ({' '}
                    <a href="https://it.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat" target="blank">
                        https://it.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat
                    </a>{' '}
                    ) dalle 09:00 del 12 agosto alle 07:59 del 6 settembre e che mantengono attiva tale iscrizione al momento dell’ordine, avranno diritto a
                    usufruire dei vantaggi esclusivi riservati agli utenti iscritti: un inseguitore solare ad asse singolo EcoFlow in omaggio e un’estensione di
                    due anni della garanzia per il dispositivo EcoFlow DELTA Pro 3 acquistato. <br />
                    Ogni indirizzo e-mail può beneficiare dell’estensione della garanzia di due anni su un solo dispositivo EcoFlow DELTA Pro 3 acquistato.
                    L'indirizzo e-mail utilizzato dall'acquirente per effettuare l'ordine deve essere lo stesso indirizzo e-mail utilizzato per iscriversi alle
                    e-mail di marketing di EcoFlow DELTA Pro 3 durante il periodo di prevendita e deve rimanere iscritto al momento del pagamento e per le 24
                    ore successive al pagamento. Se l'acquirente annulla l'iscrizione al momento del pagamento e entro le 24 ore successive, non potrà ricevere
                    l'e-mail di conferma per ottenere i vantaggi relativi all’estensione della garanzia. L'acquirente può controllare l'e-mail di aggiornamento
                    dell'ordine dopo 24 ore dal pagamento oppure registrare un account EcoFlow e quindi accedere all’indirizzo{' '}
                    <a
                        href="https://account.ecoflow.com/login?return_to=it.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=it.ecoflow.com/
                    </a>{' '}
                    per avere conferma che l’estensione della garanzia di 2 anni è stata aggiunta all'ordine ritenuto idoneo. L’estensione della garanzia di 2
                    anni visualizzata nella pagina dell'ordine è un prodotto virtuale che non verrà consegnato fisicamente. Si prega di tutelare le informazioni
                    sulla garanzia, quali il codice SN, la prova di acquisto (fattura) e l'e-mail di emissione dell’estensione della garanzia da eventuali fughe
                    di informazioni. EcoFlow non è responsabile per eventuali perdite finanziarie dovute alla fuga di informazioni sulla garanzia da parte dei
                    clienti.
                </>
            ),
        },
        {
            title: (
                <>
                    Visita il sito{' '}
                    <a href="https://it.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat" target="blank">
                        https://it.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat
                    </a>{' '}
                    per consultare il testo integrale dei Termini e condizioni.
                </>
            ),
        },

        {
            title: (
                <>
                    <strong>2. Campagna omaggi per la serie DELTA 3: </strong>
                </>
            ),
        },
        {
            title: ' Tra i prodotti idonei: Power station portatile serie EcoFlow DELTA 3 e relativi set',
        },
        {
            title: ' Omaggio dedicato: 1 × EcoFlow RAPID (5.000 mAh)',
        },
        {
            title: ' Quantità di omaggi disponibili: 200',
        },

        {
            title: (
                <>
                    <strong>3. Campagna omaggi per la serie RIVER 3: </strong>
                </>
            ),
        },
        {
            title: 'Tra i prodotti idonei: Power station portatile serie EcoFlow RIVER 3 e relativi set',
        },
        {
            title: 'Omaggio dedicato: 1 × Lampada da campeggio EcoFlow',
        },
        {
            title: 'Quantità di omaggi disponibili: 200',
        },

        {
            title: (
                <>
                    <strong>4. Campagna omaggi per la power bank Rapid: </strong>
                </>
            ),
        },
        {
            title: 'Tra i prodotti idonei: Power bank magnetica EcoFlow RAPID (5.000/10.000 mAh) e relativi set',
        },
        {
            title: 'Omaggio dedicato: 1 × Borsa a tracolla EcoFlow o 1 x Borsa di stoffa EcoFlow',
        },
        {
            title: 'Quantità di omaggi disponibili: 200',
        },
        {
            title: (
                <>
                    <strong>Nota:</strong>
                </>
            ),
        },
        {
            title: '1. L’inizio della campagna corrisponde al momento in cui il prodotto è disponibile per la vendita; le informazioni sull’apertura delle vendite presenti sul sito web ufficiale hanno comunque la precedenza. ',
        },
        {
            title: (
                <>
                    2. I primi 200 ordini sopra menzionati vengono conteggiati nei seguenti 5 siti Web ufficiali EcoFlow:{' '}
                    <a href="https://eu.ecoflow.com" target="blank">
                        eu.ecoflow.com
                    </a>
                    ,{' '}
                    <a href="https://de.ecoflow.com" target="blank">
                        de.ecoflow.com
                    </a>
                    ,
                    <a href="https://fr.ecoflow.com" target="blank">
                        fr.ecoflow.com
                    </a>
                    ,{' '}
                    <a href="https://it.ecoflow.com" target="blank">
                        it.ecoflow.com
                    </a>{' '}
                    ed{' '}
                    <a href="https://es.ecoflow.com" target="blank">
                        es.ecoflow.com
                    </a>
                    . In totale verranno distribuiti 200 omaggi attraverso i 5 siti Web. L'inizio del conteggio si basa sull'annuncio. Gli ordini idonei vengono
                    ordinati in base all'ordine cronologico di pagamento. Se il regalo è esaurito, l’offerta sarà terminata senza ulteriori avvisi dal sito web.
                    Se l'ordine è idoneo, l’omaggio verrà automaticamente aggiunto all'ordine entro 24 ore dal pagamento. I clienti potranno visualizzare
                    l’omaggio all’interno dell’ordine accedendo al proprio account ({' '}
                    <a
                        href="https://account.ecoflow.com/login?return_to=it.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=it.ecoflow.com/
                    </a>{' '}
                    ) tramite il sito web ufficiale su hanno effettuato l’acquisto.
                </>
            ),
        },
        {
            title: "3. Se viene emesso un rimborso per l’ordine originale, l'omaggio dovrà essere restituito. Con l’emissione del rimborso, perderà inoltre validità l’estensione di due anni della garanzia di EcoFlow DELTA Pro 3 (riservata in esclusiva agli utenti che si sono iscritti durante la campagna di prevendita). Non verrà fornita alcuna comunicazione separata sull’annullamento.",
        },
        {
            title: (
                <>
                    <strong>Disposizioni generali:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    1. Per qualsiasi problema riscontrato durante la promozione, contatta l'assistenza all’indirizzo{' '}
                    <a href="mailto:support.eu@ecoflow.com">support.eu@ecoflow.com</a>.
                </>
            ),
        },
        {
            title: '2. Nella misura consentita dalla legge applicabile, EcoFlow può decidere di modificare queste regole o di annullare la promozione in qualsiasi momento. In caso di frode o abuso in relazione alla promozione, ci riserviamo il diritto di escludere qualsiasi cliente dalla promozione.',
        },
        {
            title: '3. I Partecipanti alla Campagna accettano di essere vincolati dai termini e condizioni qui disposti e comprendono che le decisioni di EcoFlow sono definitive e vincolanti. Non sarà intrattenuta alcuna corrispondenza e le decisioni si intendono inappellabili. EcoFlow si riserva il diritto di interpretazione ultima e definitiva per la presente campagna.',
        },
        {
            title: '4. Tutti gli ordini devono essere conformi al contratto di acquisto e alla politica di reso di EcoFlow durante la promozione della campagna di sconti.',
        },
        {
            title: '5. La promozione non può essere applicata agli ordini di grossisti o distributori.',
        },
        {
            title: '6. Qualsiasi comportamento non autorizzato o fraudolento comporterà la squalifica dei partecipanti.',
        },
        {
            title: '7. I partecipanti devono rispettare tutte le leggi e le normative vigenti.',
        },
        {
            title: '8. EcoFlow si riserva il diritto di interrompere, annullare o modificare la promozione in qualsiasi momento nel corso della promozione stessa. Eventuali modifiche saranno annunciate sul sito ufficiale di EcoFlow.',
        },
        {
            title: "9. Tutti i premi di questa promozione sono in quantità limitata e sono disponibili in base all'ordine di arrivo dell’ordine di acquisto. Qualsiasi questione non contemplata nelle presenti disposizioni sarà gestita secondo l'interpretazione finale di EcoFlow.",
        },
        {
            title: '10. EcoFlow non si assume alcuna responsabilità per ritardi negli inserimenti dovuti a qualunque motivo, inclusi, in via esemplificativa ma non esaustiva, errori di trasmissione di rete.',
        },
        {
            title: '11. EcoFlow non sarà responsabile per eventuali perdite o danni diretti o indiretti subiti da qualsiasi parte, compresi i partecipanti, connessi a o derivanti da atti o omissioni nel contesto di questa campagna o comunque altrimenti riconducibili alla stessa.',
        },
        {
            title: '12. I partecipanti accettano di sollevare ed esonerare EcoFlow da qualsiasi responsabilità e reclamo, ivi inclusi violazione del contratto, illecito civile, negligenza o qualsiasi altra causa di azione legale o di equità, derivante da o in qualsiasi modo collegata a questa campagna o alla partecipazione alla campagna.',
        },
    ],
    es: [
        {
            title: <strong>Términos y condiciones de la campaña de regalos de EcoFlow DELTA Pro 3, DELTA 3, RIVER 3 y Banco de energía magnético RAPID</strong>,
        },
        {
            title: 'La campaña de regalos EcoFlow DELTA Pro 3, DELTA 3, RIVER 3 y Banco de energía magnético RAPID se llevará a cabo del 12 de agosto de 2024 a las 9 AM (CET) al 31 de diciembre de 2024 a las 9 AM (CET). EcoFlow se reserva el derecho de acortar o prorrogar el tiempo de duración de la campaña a su exclusivo criterio y sin previo aviso.',
        },
        {
            title: <strong>Elegibilidad</strong>,
        },
        {
            title: 'La campaña está disponible para todos los ciudadanos europeos mayores de 18 años a partir de las 9 AM del 12 de agosto de 2024 (CET).',
        },
        {
            title: <strong>Detalles de la campaña</strong>,
        },
        {
            title: 'Al ingresar tu dirección de correo electrónico y confirmar tu suscripción, aceptarás los Términos y Condiciones de marketing por correo, incluyendo la suscripción de correos de marketing y la recepción de actualizaciones del equipo de EcoFlow.',
        },

        {
            title: (
                <>
                    <strong>1. Campaña de precalentamiento del sistema de batería solar para el hogar DELTA Pro 3:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    Los primeros 200 pedidos de EcoFlow DELTA Pro 3 y sus paquetes realizados entre las 9 AM del 6 de septiembre y las 9 AM del 6 de octubre
                    recibirán un seguidor solar de un solo eje EcoFlow gratis. Cada pedido está limitado a un{' '}
                    <a href="https://es.ecoflow.com/products/single-axis-solar-tracker" target="blank">
                        seguidor solar de un solo eje EcoFlow.
                    </a>{' '}
                    <br />
                    De estos primeros 200 pedidos de DELTA Pro 3 y su paquete mencionado anteriormente, si el comprador se ha suscrito a los correos
                    electrónicos de marketing sobre EcoFlow DELTA Pro 3 en esta página de evento de precalentamiento{' '}
                    <a href="https://es.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat" target="blank">
                        https://es.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat
                    </a>{' '}
                    desde las 9 AM del 12 de agosto hasta las 7:59 AM del 6 de septiembre, y sigue siendo suscriptor cuando se realiza el pedido, el comprador
                    será elegible para los beneficios exclusivos para suscriptores: un Seguidor solar de un solo eje EcoFlow GRATIS y una garantía extendida de
                    dos años para el EcoFlow DELTA Pro 3 adquirido.
                    <br />
                    Cada dirección de correo electrónico cumple los requisitos para disfrutar de las ventajas de la garantía ampliada de dos años en un solo
                    EcoFlow DELTA Pro 3 comprado. La dirección de correo electrónico utilizada por el comprador para realizar el pedido debe ser la misma que la
                    dirección de correo electrónico utilizada para suscribirse a los correos electrónicos de marketing de EcoFlow DELTA Pro 3 durante el periodo
                    de precalentamiento y debe permanecer suscrita en el momento del pago y dentro de las 24 horas posteriores al pago. Si el comprador cancela
                    su suscripción en el momento del pago y dentro de las 24 horas posteriores al pago, no podrá recibir el correo electrónico de confirmación
                    de las ventajas de la garantía ampliada. El comprador puede consultar el correo electrónico de actualización del pedido 24 horas después de
                    haber realizado el pago, o registrarse para una cuenta de EcoFlow y luego iniciar sesión en{' '}
                    <a
                        href="https://account.ecoflow.com/login?return_to=es.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=es.ecoflow.com/
                    </a>{' '}
                    para confirmar que la garantía ampliada de 2 años se ha añadido al pedido que cumpla los requisitos. La garantía ampliada de 2 años que se
                    muestra en la página del pedido es un producto virtual que no se emitirá físicamente. Proteja su información de garantía, como el código de
                    número de serie, el comprobante de compra (factura) y el correo electrónico de emisión de garantía ampliada para evitar la filtración de
                    datos. EcoFlow no se responsabiliza de ninguna pérdida económica ocasionada por la filtración de información sobre la garantía causada por
                    los clientes.
                </>
            ),
        },
        {
            title: (
                <>
                    Para ver todos los términos y condiciones, visita{' '}
                    <a href="https://es.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat" target="blank">
                        https://es.ecoflow.com/pages/delta-pro-3-portable-power-station-preheat.
                    </a>{' '}
                </>
            ),
        },
        {
            title: (
                <>
                    <strong>2. Campaña de regalos para la serie DELTA 3: </strong>
                </>
            ),
        },
        {
            title: 'Los productos que cumplen los requisitos son: Estación de energía portátil de la serie EcoFlow DELTA 3 y sus paquetes',
        },
        {
            title: 'Regalo exclusivo: 1 × EcoFlow RAPID (5000 mAh)',
        },
        {
            title: 'Cantidades disponibles de regalos: 200',
        },

        {
            title: (
                <>
                    <strong>3. Campaña de regalos para la serie RIVER 3: </strong>
                </>
            ),
        },
        {
            title: 'Los productos que cumplen los requisitos son: Estación de energía portátil de la serie EcoFlow RIVER 3 y sus paquetes',
        },
        {
            title: 'Regalo exclusivo: 1 × foco de luz para camping EcoFlow',
        },
        {
            title: 'Cantidades disponibles de regalos: 200',
        },
        {
            title: (
                <>
                    <strong>4. Campaña de regalos para el banco de energía RAPID: </strong>
                </>
            ),
        },
        {
            title: 'Los productos que cumplen los requisitos son: Banco de energía magnético EcoFlow RAPID (5000/10000 mAh) y sus paquetes',
        },
        {
            title: 'Regalo exclusivo: 1 × bolso de hombro EcoFlow o 1 × bolso de mano EcoFlow',
        },
        {
            title: 'Cantidades disponibles de regalos: 200',
        },

        {
            title: (
                <>
                    <strong>Nota:</strong>
                </>
            ),
        },
        {
            title: '1. La hora de inicio de la campaña es cuando el producto está disponible para la venta, sujeto a la información de venta abierta en el sitio web oficial. ',
        },
        {
            title: (
                <>
                    2. Los primeros 200 pedidos mencionados anteriormente se contabilizan en los siguientes 5 sitios web oficiales de EcoFlow:{' '}
                    <a href="https://eu.ecoflow.com" target="_blank" rel="noreferrer">
                        eu.ecoflow.com
                    </a>
                    ,
                    <a href="https://eu.ecoflow.com" target="_blank" rel="noreferrer">
                        de.ecoflow.com
                    </a>
                    ,{' '}
                    <a href="https://eu.ecoflow.com" target="_blank" rel="noreferrer">
                        fr.ecoflow.com
                    </a>
                    ,{' '}
                    <a href="https://eu.ecoflow.com" target="_blank" rel="noreferrer">
                        it.ecoflow.com
                    </a>{' '}
                    y{' '}
                    <a href="https://eu.ecoflow.com" target="_blank" rel="noreferrer">
                        es.ecoflow.com
                    </a>
                    . En total se repartirán 200 regalos entre los 5 sitios web. El inicio del recuento se basa en el anuncio. Los pedidos que cumplan los
                    requisitos se clasifican en orden cronológico de pago. Si los regalos se agotan, la oferta se suspenderá sin más notificación por parte del
                    sitio web. Si el pedido cumple los requisitos, el regalo se añadirá automáticamente al pedido dentro de las 24 horas posteriores al pago. El
                    cliente podrá ver el regalo en el pedido iniciando sesión en la cuenta a través del sitio web oficial ({' '}
                    <a
                        href="https://account.ecoflow.com/login?return_to=es.ecoflow.com/"
                        target="blank"
                        onClick={() => {
                            signupCookie({ sector_name: 'Terms & Conditions', entry_position: 8 });
                        }}
                    >
                        https://account.ecoflow.com/login?return_to=es.ecoflow.com/.
                    </a>{' '}
                    ) donde realizó la compra.
                </>
            ),
        },
        {
            title: '3. En caso de reembolso del pedido original, se deberá devolver el regalo y se invalidará la garantía extendida de dos años para EcoFlow DELTA Pro 3 (exclusiva para suscriptores durante la campaña de precalentamiento). No se proporcionará ningún aviso de invalidación por separado.',
        },
        {
            title: (
                <>
                    <strong>Condiciones generales:</strong>
                </>
            ),
        },
        {
            title: (
                <>
                    1. Si tienes algún problema durante la promoción, contacta con <a href="mailto:support.eu@ecoflow.com">support.eu@ecoflow.com</a> para
                    obtener ayuda.
                </>
            ),
        },
        {
            title: '2. En la medida en que lo permita la ley aplicable, podremos decidir modificar estas reglas o cancelar la promoción en cualquier momento. Si se comete algún fraude o abuso relacionado con la promoción, nos reservamos el derecho de excluir a cualquier cliente de la promoción.',
        },
        {
            title: '3. Los participantes en la venta de rebajas aceptan los términos y condiciones establecidos en este documento y entienden que las decisiones de EcoFlow son definitivas y vinculantes. No se responderá correspondencia ni apelaciones. EcoFlow se reserva el derecho de hacer la interpretación final y definitiva de esta campaña.',
        },
        {
            title: '4. Todos los pedidos deben cumplir el acuerdo de compra y la política de devoluciones de EcoFlow durante la promoción.',
        },
        {
            title: '5. La promoción no se aplica a los pedidos de mayoristas o distribuidores.',
        },
        {
            title: '6. Cualquier comportamiento no autorizado o fraudulento dará lugar a la descalificación de los participantes.',
        },
        {
            title: '7. Los participantes deben cumplir con todas las leyes y regulaciones aplicables.',
        },
        {
            title: '8. EcoFlow se reserva el derecho a interrumpir, cancelar o modificar la promoción en cualquier momento durante la misma. Cualquier cambio se anunciará en el sitio web oficial de EcoFlow.',
        },
        {
            title: '9. Todos los premios de esta promoción están limitados en cantidad y están disponibles por orden de llegada. Cualquier asunto no cubierto en este documento será tratado de acuerdo con la interpretación final de EcoFlow.',
        },
        {
            title: '10. EcoFlow no asumirá responsabilidad alguna por las participaciones fuera de plazo que puedan producirse por cualquier motivo, incluidos, entre otros, errores o fallos en la transmisión de la red o internet.',
        },
        {
            title: '11. EcoFlow no será responsable de las pérdidas o daños directos o indirectos incurridos por cualquier parte, incluidos los participantes, que surjan de actos u omisiones en esta campaña, estén conectados con esta campaña o relacionados de cualquier forma con ella.',
        },
        {
            title: '12. Los participantes aceptan eximir a EcoFlow de toda reclamación y responsabilidad, incluyendo el incumplimiento de contrato, agravio, negligencia o cualquier otra causa de demanda a tenor de la ley o la equidad que surja a raíz de, o que esté de alguna manera relacionada con esta campaña o a la inscripción del participante en la campaña.',
        },
    ],
    us: [
        {
            title: <strong>T&C: </strong>,
        },
        {
            title: "*Terms and conditions apply. Early Bird Price varies by product line. Please sign up to stay informed. Early Bird Price listed on the page will be applied on EcoFlow's official website and EcoFlow Amazon store. With the Early Bird Price you can get the following benefits with eligible orders:",
        },
        {
            title: '(1) DELTA 3 Series: $150 off and a free DELTA bag with EcoFlow DELTA 3 Plus, or $649 off and a free DELTA bag on bundles (EcoFlow DELTA 3 Plus + 220W Solar Panel), valid for orders placed between September 10 and October 25, 2024',
        },
        {
            title: '(2) RAPID Series: $20 off and a free 20W charger on EcoFlow RAPID 5000mAh, or $10 off and a free 30W charger on EcoFlow RAPID 10000mAh, valid for orders placed during the launch promotion. These benefits only apply to EcoFlow RAPID Magnetic Power Bank (5000mAh/10000mAh) Silver and Light Blue Color products.',
        },
        {
            title: '- EcoFlow reserves the right to cancel the benefits and any associated orders at any time in cases of dishonesty, fraud, or any violation of these terms.',
        },
        {
            title: '**Terms and conditions apply. Free installation offer applies to EcoFlow Power Kits 5kVA 48V Power System only. Not applicable to the installation of any additional products. Some RV models may not be compatible with EcoFlow Power Kits 5kVA 48V Power System.',
        },
        {
            title: <strong>Footnote: </strong>,
        },
        {
            title: "[1] Data source: Analysis based on EcoFlow's internal test data of 1 kWh mainstream power stations in the market and their official data. DELTA 3 Plus's fast and safe charging performance is certified with a 5-star rating by SGS. Data is current as of August 28, 2024.",
        },
        {
            title: '[2,4,5,7,8] All the test results displayed on the page are based on our internal testing, subject to different conditions, including temperature variations, humidity levels, and equipment calibration standards. Please note that these results are provided for informational purposes only and should not be considered as conclusive evidence for all scenarios',
        },
        {
            title: "[3] Before using the HID function when connecting to a NAS server with Ecoflow DELTA 3 Plus, you need to download the NAS system's app and EcoFlow Power Manager app to connect to it.",
        },
        {
            title: '[6] Cable design of RAPID may vary from the one depicted in the advertisement. ',
        },
    ],
    ca: [
        {
            title: <strong>T&C: </strong>,
        },
        {
            title: "*Terms and conditions apply. Early Bird Price varies by product line. Please sign up to stay informed. Early Bird Price listed on the page will be applied on EcoFlow's official website and EcoFlow Amazon store. With the Early Bird Price you can get the following benefits with eligible orders:",
        },
        {
            title: '(1) DELTA 3 Series: $200 off and a free DELTA bag with EcoFlow DELTA 3 Plus, or $699 off and a free DELTA bag on bundles (EcoFlow DELTA 3 Plus + 160W Solar Panel), valid for orders placed between September 10 and October 25, 2024',
        },
        {
            title: '(2) RAPID Series: $10 off and a free 20W charger with EcoFlow RAPID 5000mAh, or a free 30W charger with EcoFlow RAPID 10000mAh, valid for orders placed during the launch promotion. These benefits only apply to EcoFlow RAPID Magnetic Power Bank (5000mAh/10000mAh) Silver and Light Blue Color products.',
        },
        {
            title: '- EcoFlow reserves the right to cancel the coupon and any associated orders at any time in cases of dishonesty, fraud, or any violation of these terms.',
        },
        {
            title: '**Terms and conditions apply. Free installation offer applies to EcoFlow Power Kits 5kVA 48V Power System only. Not applicable to the installation of any additional products. Some RV models may not be compatible with EcoFlow Power Kits 5kVA 48V Power System.',
        },
        {
            title: <strong>Footnote: </strong>,
        },
        {
            title: "[1] Data source: Analysis based on EcoFlow's internal test data of 1 kWh mainstream power stations in the market and their official data. DELTA 3 Plus's fast and safe charging performance is certified with a 5-star rating by SGS. Data is current as of August 28, 2024.",
        },
        {
            title: '[2,4,5,7,8] All the test results displayed on the page are based on our internal testing, subject to different conditions, including temperature variations, humidity levels, and equipment calibration standards. Please note that these results are provided for informational purposes only and should not be considered as conclusive evidence for all scenarios',
        },
        {
            title: "[3] Before using the HID function when connecting to a NAS server with Ecoflow DELTA 3 Plus, you need to download the NAS system's app and EcoFlow Power Manager app to connect to it.",
        },
        {
            title: '[6] Cable design of RAPID may vary from the one depicted in the advertisement.',
        },
    ],
    au: [
        {
            title: <strong>T&C: </strong>,
        },
        {
            title: 'All the test results displayed on the page are based on our internal testing, subject to different conditions, including temperature variations, humidity levels, and equipment calibration standards. Please note that these results are provided for informational purposes only and should not be considered as conclusive evidence for all scenarios. Data was tested in a controlled laboratory environment and actual user experience may vary.',
        },
        {
            title: '1. The runtime is based on laboratory tests conducted with common household appliances under normal room temperature conditions. The "double runtime" claim specifically refers to tests using a 3W light or Wi-Fi router.',
        },
        {
            title: '2. The noise level data is based on laboratory tests conducted at a room temperature of 89.6°F (32°C). Actual use may have slight deviations due to variations in the real environment.',
        },
        {
            title: '3. The input and output wattage of the Smart Extra Battery will decrease to 100W when ambient temperature is higher than 95°F (35°C).',
        },
        {
            title: '4. The IP54 water-resistance rating applies only to the battery pack, not the entire package. It does not prevent water immersion but can prevent fire or explosion in the event of a short circuit if the battery is splashed with water or rain, ensuring user safety and property protection',
        },
    ],
};
